var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{attrs:{"tag":"section"}},[_c('post-category-preview-list',{attrs:{"entries":_vm.entries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }